import Link, { LinkProps } from 'next/link';
import React, { HTMLAttributes } from 'react';

type Props = LinkProps & {
  target?: string;
  onClick?: HTMLAttributes<HTMLAnchorElement>['onClick'];
  'data-testid'?: string;
  children?: React.ReactNode;
};

const UnderlinedLink: React.FC<Props> = ({
  children,
  onClick,
  target,
  ...props
}) => (
  <Link
    {...props}
    className="hyperlink"
    data-testid={props['data-testid']}
    onClick={onClick}
    prefetch={false}
    target={target}
  >
    {children}
  </Link>
);

export default UnderlinedLink;
